"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var html_to_image_1 = require("html-to-image");
var chromatism_1 = require("chromatism");
var Snackbar_1 = tslib_1.__importDefault(require("../Snackbar"));
var Loading_1 = tslib_1.__importDefault(require("../Loading"));
var interface_1 = require("./interface");
var theme_1 = require("../../utils/theme");
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
var locale_1 = require("../../common/locale");
var GLASS_SIZE = 120;
var GLASS_SCALE = 10;
var GLASS_BETWEEN = 8;
var GLASS_BOUNDERY = 142;
var CANVAS_BACKGROUND = '#f2f2f2';
var NewEyedropper = (function (_super) {
    tslib_1.__extends(NewEyedropper, _super);
    function NewEyedropper() {
        var _a, _b, _c;
        var _this = _super.apply(this, arguments) || this;
        _this.snapShotRef = React.createRef();
        _this.glassCanvasRef = React.createRef();
        _this.glassCtx = null;
        _this.snapShotSize = {
            width: ((_a = _this.props.containerDom) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0,
            height: ((_b = _this.props.containerDom) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0
        };
        _this.canvasBuffer = document.createElement("canvas");
        _this.canvasBufferCtx = _this.canvasBuffer.getContext('2d');
        _this.state = {
            visible: (_c = _this.props.visible) !== null && _c !== void 0 ? _c : true,
            relateToPicPoint: { x: 0, y: 0 },
            color: undefined,
            isShowHex: true,
            isInViewPort: false,
            snapshot: '',
        };
        _this.browerCheck = function () {
            if (docs_user_agent_1.default.isSafari) {
                Snackbar_1.default.show({
                    message: locale_1.i18n('eyedropperFailedSafari'),
                    type: 'error',
                    duration: 5000,
                });
                return false;
            }
            if (docs_user_agent_1.default.isOldEdge) {
                Snackbar_1.default.show({
                    message: locale_1.i18n('eyedropperFailedEdge'),
                    type: 'error',
                    duration: 5000,
                });
                return false;
            }
            return true;
        };
        _this.handleClick = function (e) {
            var _a, _b;
            e.stopPropagation();
            if (_this.props.onColorChange) {
                var color = _this.getGlassColor().hex;
                (_b = (_a = _this.props).onColorChange) === null || _b === void 0 ? void 0 : _b.call(_a, color);
            }
            _this.hide();
        };
        _this.handleMouseMove = function (e) {
            _this.updateRelateToPicPoint(e);
            _this.drawGlass();
        };
        _this.handleSwitchColor = function () {
            _this.setState({ isShowHex: !_this.state.isShowHex });
        };
        _this.handleCopyColor = function () {
            var color = _this.state.color;
            try {
                color && navigator.clipboard.writeText(_this.colorForShow);
                Snackbar_1.default.show({
                    message: locale_1.i18n('copySuccessed'),
                    type: 'success',
                    duration: 3000,
                });
            }
            catch (e) {
                console.log(e);
                Snackbar_1.default.show({
                    message: locale_1.i18n('copyFailed'),
                    type: 'error',
                    duration: 3000,
                });
            }
        };
        _this.handleLeave = function () {
            setTimeout(function () {
                _this.setState({ isInViewPort: false });
            }, 0);
        };
        _this.handleContextMenu = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };
        _this.handleBodyClick = function (e) {
            if (!_this.isInViewPort) {
                _this.hide();
                return;
            }
            var clientX = e.clientX, clientY = e.clientY;
            if (_this.snapShotRef.current) {
                var rect = _this.snapShotRef.current.getBoundingClientRect();
                if (clientX >= rect.left && clientX <= rect.right
                    && clientY >= rect.top && clientY <= rect.bottom) {
                    return;
                }
            }
            _this.hide();
        };
        _this.handleKeyDown = function (e) {
            e.stopPropagation();
            switch (e.key) {
                case interface_1.EyeDropperKeyboardEventKey.esc:
                    _this.hide();
                    break;
                case interface_1.EyeDropperKeyboardEventKey.enter:
                case interface_1.EyeDropperKeyboardEventKey.space:
                    if (!_this.isInViewPort) {
                        return;
                    }
                    _this.handleClick(e);
                    break;
                case interface_1.EyeDropperKeyboardEventKey.copy:
                    _this.handleCopyColor();
                    break;
                case interface_1.EyeDropperKeyboardEventKey.switch:
                    _this.handleSwitchColor();
                    break;
            }
        };
        _this.preventBlur = function (e) {
            e.preventDefault();
        };
        _this.onVisibleChange = function (visible) {
            if (_this.props.onVisibleChange) {
                _this.props.onVisibleChange(visible);
            }
        };
        _this.addGlobalListener = function () {
            document.body.addEventListener('click', _this.handleBodyClick);
            window.addEventListener('resize', _this.hide);
            window.addEventListener('scroll', _this.hide);
            window.addEventListener('keydown', _this.handleKeyDown, { capture: true });
        };
        _this.removeGlobalListener = function () {
            document.body.removeEventListener('click', _this.handleBodyClick);
            window.removeEventListener('resize', _this.hide);
            window.removeEventListener('scroll', _this.hide);
            window.removeEventListener('keydown', _this.handleKeyDown, { capture: true });
        };
        _this.getAdjustRenderPosition = function (container) {
            var parentNode = container === null || container === void 0 ? void 0 : container.parentNode;
            if (parentNode && window.getComputedStyle(parentNode).position === 'static') {
                container.style.position = 'relative';
            }
            var wrapperLeft = container.offsetLeft + parentNode.scrollLeft;
            var wrapperTop = container.offsetTop + parentNode.scrollTop;
            if (wrapperLeft || wrapperTop) {
                return {
                    'left': wrapperLeft + "px",
                    'top': wrapperTop + "px",
                };
            }
        };
        _this.updateRelateToPicPoint = function (e) {
            var _a;
            var containerDom = _this.props.containerDom;
            var rec = (_a = _this.snapShotRect) !== null && _a !== void 0 ? _a : containerDom.getBoundingClientRect();
            var _b = rec || { left: 0, top: 0 }, left = _b.left, top = _b.top;
            _this.relateToPicPoint = { x: e.clientX - left, y: e.clientY - top };
        };
        _this.getGlassPosition = function () {
            if (!_this.relateToPicPoint) {
                return { x: 0, y: 0 };
            }
            var containerDom = _this.props.containerDom;
            var _a = containerDom.getBoundingClientRect(), width = _a.width, height = _a.height;
            var _b = _this.relateToPicPoint, x = _b.x, y = _b.y;
            var glassX;
            var glassY;
            var xBias = GLASS_SIZE / 2;
            var yBias = GLASS_SIZE / 2 + GLASS_BETWEEN;
            var bottomGap = height - y;
            var rightGap = width - x;
            glassY = bottomGap < GLASS_BOUNDERY ? y - yBias : y + yBias;
            glassX = rightGap < GLASS_BOUNDERY ? x - xBias : x + xBias;
            return { x: glassX, y: glassY };
        };
        _this.drawImageSmoothingEnable = function (context, enable) {
            context.mozImageSmoothingEnabled = enable;
            context.webkitImageSmoothingEnabled = enable;
            context.msImageSmoothingEnabled = enable;
            context.imageSmoothingEnabled = enable;
        };
        _this.drawGlassImg = function () {
            var _a = _this.relateToPicPoint, x = _a.x, y = _a.y;
            var glassSizeWithoutCenter = GLASS_SIZE - GLASS_SCALE;
            var glassSkewing = GLASS_SCALE;
            _this.glassCtx.fillStyle = CANVAS_BACKGROUND;
            _this.glassCtx.fillRect(0, 0, GLASS_SIZE, GLASS_SIZE);
            _this.drawImageSmoothingEnable(_this.glassCtx, false);
            _this.glassCtx.drawImage(_this.canvasBuffer, Math.floor(x - (glassSizeWithoutCenter / 2 / GLASS_SCALE)), Math.floor(y - (glassSizeWithoutCenter / 2 / GLASS_SCALE)), Math.floor((glassSizeWithoutCenter / GLASS_SCALE) + 1), Math.floor((glassSizeWithoutCenter / GLASS_SCALE) + 1), -glassSkewing, -glassSkewing, GLASS_SIZE + glassSkewing, GLASS_SIZE + glassSkewing);
        };
        _this.drawGlass = function () {
            if (!_this.glassCtx) {
                return;
            }
            _this.drawGlassImg();
            var color = _this.getGlassColor();
            _this.setState({
                color: color,
                relateToPicPoint: _this.relateToPicPoint,
                isInViewPort: true,
            });
        };
        _this.getGlassColor = function () {
            var _a = _this.relateToPicPoint, x = _a.x, y = _a.y;
            var data = _this.canvasBufferCtx.getImageData(x, y, 1, 1).data;
            data = data.slice(0, 3);
            return chromatism_1.convert("rgb(" + data.join(', ') + ")");
        };
        _this.addLoading = function () {
            clearTimeout(_this.loadingTimer);
            if (_this.loadingInstance) {
                _this.loadingInstance.close();
            }
            _this.loadingTimer = window.setTimeout(function () {
                _this.loadingInstance = Loading_1.default.show({});
            }, 500);
        };
        _this.removeLoading = function () {
            clearTimeout(_this.loadingTimer);
            if (_this.loadingInstance) {
                _this.loadingInstance.close();
            }
        };
        _this.generateSnapShot = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var containerDom, imgUri;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.browerCheck()) {
                            return [2];
                        }
                        containerDom = this.props.containerDom;
                        this.addLoading();
                        return [4, html_to_image_1.toSvg(containerDom).catch(function (err) {
                                console.error('toSvg failed', err);
                                _this.hide();
                            })];
                    case 1:
                        imgUri = (_a.sent()) || '';
                        this.removeLoading();
                        this.addGlobalListener();
                        this.setState({
                            snapshot: imgUri,
                            visible: true,
                        });
                        return [2];
                }
            });
        }); };
        _this.init = function () {
            var _a = _this.props, containerDom = _a.containerDom, initialPosition = _a.initialPosition;
            var _b = containerDom.getBoundingClientRect(), left = _b.left, right = _b.right, top = _b.top, bottom = _b.bottom;
            var _c = _this.snapShotSize, width = _c.width, height = _c.height;
            _this.snapShotRect = _this.snapShotRef.current.getBoundingClientRect();
            _this.glassCtx = _this.glassCanvasRef.current.getContext('2d');
            _this.canvasBuffer.width = width;
            _this.canvasBuffer.height = height;
            _this.canvasBufferCtx.fillStyle = CANVAS_BACKGROUND;
            _this.canvasBufferCtx.fillRect(0, 0, width, height);
            _this.canvasBufferCtx.drawImage(_this.snapShotRef.current, 0, 0);
            if (!_this.relateToPicPoint) {
                var updatedPoint = initialPosition !== null && initialPosition !== void 0 ? initialPosition : { clientX: window.innerWidth / 2, clientY: window.innerHeight / 2 };
                _this.updateRelateToPicPoint(updatedPoint);
            }
            _this.onVisibleChange(true);
            var _d = _this.relateToPicPoint, x = _d.x, y = _d.y;
            if (x >= left
                && x <= right
                && y >= top
                && y <= bottom) {
                _this.drawGlass();
            }
        };
        _this.hide = function () {
            var _a;
            _this.removeGlobalListener();
            var endPosition = (_a = _this.props.initialPosition) !== null && _a !== void 0 ? _a : { clientX: window.innerWidth / 2, clientY: window.innerHeight / 2 };
            _this.updateRelateToPicPoint(endPosition);
            _this.onVisibleChange(false);
            _this.setState({
                visible: false,
                snapshot: '',
            });
        };
        _this.handleEffect = function () {
            _this.generateSnapShot();
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            if (!prevState.visible && _this.state.visible && !_this.state.snapshot) {
                _this.handleEffect();
            }
        };
        _this.componentDidMount = function () {
            _this.state.visible && _this.handleEffect();
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.state, snapshot = _c.snapshot, visible = _c.visible, isInViewPort = _c.isInViewPort, color = _c.color;
            if (!visible || !snapshot) {
                return null;
            }
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, containerDom = _d.containerDom;
            var _e = _this.snapShotSize, width = _e.width, height = _e.height;
            var cls = classNames(className, prefixCls + "-eyedropper");
            var glassPosistion = _this.getGlassPosition();
            var glassVisibilityStyle = isInViewPort ? 'visible' : 'hidden';
            var glassStyle = {
                visibility: glassVisibilityStyle,
                left: glassPosistion.x,
                top: glassPosistion.y,
                position: 'absolute',
            };
            return react_dom_1.default.createPortal(h("div", { className: cls, style: tslib_1.__assign(tslib_1.__assign({ width: width, height: height }, _this.getAdjustRenderPosition(containerDom)), style), onMouseMove: _this.handleMouseMove, onMouseDown: _this.preventBlur, onClick: function (e) { _this.handleClick(e); }, onContextMenu: _this.handleContextMenu },
                h("canvas", { className: classNames(prefixCls + "-eyedropper-canvas"), width: width, height: height, onMouseLeave: _this.handleLeave }),
                h("div", { className: classNames(prefixCls + "-eyedropper-mouse"), style: { left: (_a = _this.relateToPicPoint) === null || _a === void 0 ? void 0 : _a.x, top: (_b = _this.relateToPicPoint) === null || _b === void 0 ? void 0 : _b.y, visibility: glassVisibilityStyle } }),
                h("div", { className: classNames(prefixCls + "-eyedropper-glass"), style: glassStyle },
                    h("span", { className: classNames(prefixCls + "-eyedropper-glass-center") }),
                    color && h("span", { className: prefixCls + "-eyedropper-glass-color" },
                        " ",
                        _this.colorForShow,
                        " "),
                    h("canvas", { className: prefixCls + "-eyedropper-glass-canvas", width: GLASS_SIZE, height: GLASS_SIZE, style: { width: GLASS_SIZE, height: GLASS_SIZE }, ref: _this.glassCanvasRef })),
                h("img", { className: classNames(prefixCls + "-eyedropper-img"), src: snapshot, ref: _this.snapShotRef, onLoad: _this.init, onError: function (err) {
                        _this.hide();
                        console.error('image create error', err);
                    } })), containerDom.parentNode);
        };
        return _this;
    }
    NewEyedropper.getDerivedStateFromProps = function (props, state) {
        if (typeof props.visible === 'boolean') {
            return { visible: props.visible };
        }
        return null;
    };
    Object.defineProperty(NewEyedropper.prototype, "isInViewPort", {
        get: function () {
            return this.state.isInViewPort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewEyedropper.prototype, "colorForShow", {
        get: function () {
            var _a = this.state, color = _a.color, isShowHex = _a.isShowHex;
            return isShowHex ? color === null || color === void 0 ? void 0 : color.hex : "rgb(" + (color === null || color === void 0 ? void 0 : color.rgb.r) + "," + (color === null || color === void 0 ? void 0 : color.rgb.g) + "," + (color === null || color === void 0 ? void 0 : color.rgb.b) + ")";
        },
        enumerable: false,
        configurable: true
    });
    NewEyedropper.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return NewEyedropper;
}(React.Component));
exports.default = NewEyedropper;
NewEyedropper.defaultProps = {
    containerDom: typeof document !== 'undefined' ? document.body : undefined,
};
